import { h, render, Fragment } from 'preact';
import ProductContext from './product-context';
import KitProductContext from './kit/product-context';
import Product from './product';

export default (element, data) => {
  const ProductIndex = (props) => (
    <ProductContext data={data}>
      {data.isKit && (
        <KitProductContext data={data}>
          <Product {...props} />
        </KitProductContext>
      )}
      {!data.isKit && <Product {...props} />}
    </ProductContext>
  );

  const init = () => {
    render(<ProductIndex {...data} />, element);
  };

  init();
};
